"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearningTableBody = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var helpers_1 = require("../helpers");
var LearningTableBodyGroup_1 = require("./LearningTableBodyGroup");
var LearningTableBodyEmptyRow_1 = require("./LearningTableBodyEmptyRow");
var LearningTableBody = /** @class */ (function (_super) {
    tslib_1.__extends(LearningTableBody, _super);
    function LearningTableBody() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeTimeout = false;
        _this.state = {
            expandIndex: {},
        };
        _this.groupToggle = function (event, courseData) {
            if (_this.activeTimeout) {
                return null;
            }
            var _a = _this.props, tableWrapperRef = _a.tableWrapperRef, expandableWrapper = _a.expandableWrapper;
            // find, if current row is in range [0, maxVisibleRowCount-1]
            var clickedRow = event.currentTarget.parentElement.parentElement.parentElement;
            var inTable = $(tableWrapperRef.current)
                .find('tbody > .learning-table-body-main-row')
                .toArray()
                .indexOf(clickedRow);
            var uniqueExpandKey = "".concat(courseData.name, " ").concat(courseData.id);
            if (inTable < _this.props.maxVisibleRowCount) {
                _this.activeTimeout = true;
                var el_1 = $(clickedRow).next();
                var height_1 = el_1.height();
                if (_this.state.expandIndex[uniqueExpandKey]) {
                    expandableWrapper.decreaseHeight(height_1);
                    setTimeout(function () {
                        _this.activeTimeout = false;
                    }, 100);
                }
                else {
                    expandableWrapper.increaseHeight(height_1);
                    setTimeout(function () {
                        expandableWrapper.increaseHeight(el_1.height() - height_1);
                        _this.activeTimeout = false;
                    }, 100);
                }
            }
            else {
                _this.activeTimeout = false;
            }
            _this.setExpendInex(uniqueExpandKey);
        };
        return _this;
    }
    LearningTableBody.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.isTableExpanded) {
            this.props.coursesData.map(function (item) {
                var uniqueExpandKey = "".concat(item.name, " ").concat(item.id);
                _this.setExpendInex(uniqueExpandKey);
            });
        }
    };
    LearningTableBody.prototype.setExpendInex = function (uniqueExpandKey) {
        this.setState(function (prevState) {
            var _a;
            return ({
                expandIndex: tslib_1.__assign(tslib_1.__assign({}, prevState.expandIndex), (_a = {}, _a[uniqueExpandKey] = !prevState.expandIndex[uniqueExpandKey], _a)),
            });
        });
    };
    LearningTableBody.prototype.render = function () {
        var _this = this;
        var _a = this.props, coursesData = _a.coursesData, columns = _a.columns, isTableExpanded = _a.isTableExpanded, dictionary = _a.dictionary, isMobile = _a.isMobile, sortOrder = _a.sortOrder, sortColumn = _a.sortColumn, maxVisibleRowCount = _a.maxVisibleRowCount, tableUniqueId = _a.tableUniqueId;
        if (!coursesData || !coursesData.length) {
            return React.createElement(LearningTableBodyEmptyRow_1.LearningTableBodyEmptyRow, { isMobile: isMobile, columnQuantity: columns.length });
        }
        var sortedRows = (0, helpers_1.sortTableRows)(coursesData, sortOrder, sortColumn);
        return (React.createElement(React.Fragment, null, sortedRows.map(function (courseData, index) {
            var isInvisible = index > maxVisibleRowCount - 1 && !isTableExpanded;
            return (React.createElement(LearningTableBodyGroup_1.LearningTableBodyGroup, { courseData: courseData, columns: columns, groupIndex: index, groupToggle: _this.groupToggle, expandGroupIndex: _this.state.expandIndex, dictionary: dictionary, isMobile: isMobile, isInvisible: isInvisible, key: index, tableUniqueId: tableUniqueId }));
        })));
    };
    return LearningTableBody;
}(React.Component));
exports.LearningTableBody = LearningTableBody;
